import { createGoal as _createGoal } from '@griply/services';
import { NewGoal } from '@griply/types';
import {
  collection,
  doc,
  serverTimestamp,
  setDoc,
  Timestamp,
} from 'firebase/firestore';

import { getAuthentication, getDatabase } from './helpers';

export const createGoal = async (goal: NewGoal) => {
  const user = (await getAuthentication()).currentUser;

  if (!user) {
    throw Error('unauthenticated');
  }

  const db = getDatabase();

  return _createGoal({
    goal,
    userId: user.uid,
    collection,
    doc,
    setDoc,
    db,
    serverTimestamp,
    timestampFromDate: (date: Date) => Timestamp.fromDate(date),
  });
};
